import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { SrRefundRow, SrRefundService, SrTravelBillSpecGet } from '@app/services/sr-refund.service';

@Component({ selector: 'tt-sr-travel-bill-spec', templateUrl: './sr-travel-bill-spec.component.html', styleUrls: ['./sr-travel-bill-spec.component.css'], standalone: false })
export class SrTravelBillSpecComponent implements OnInit {
    public page?: SrTravelBillSpecGet;
    public specifications: SrRefundRow[] = [];
    public error = '';
    constructor(private readonly refund: SrRefundService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) {
        this.navigator = useNavigatorFor(navigator, this);
    }
    public async ngOnInit(): Promise<void> {
        try {
            this.page = await this.refund.getTravelBillSpec({ travelbill_no: String(this.navigator?.params['travelbill_no'] ?? ''),
                argtype: String(this.navigator?.params['argtype'] ?? ''), argvalue: String(this.navigator?.params['argvalue'] ?? '') });
            this.specifications = [];
            this.specifications = await this.refund.getTravelBillSpecSummary(this.page);
        } catch (error) { this.error = error instanceof Error ? error.message : String(error); }
    }
    public openItem({ item, event }: { item: SrRefundRow; event: MouseEvent }): void {
        if (!item.item_state) return;
        const to = ['srtravelbill', 'srtravelbillspec', 'srreportmenu', 'srrefundbasis', 'srrefundinputcrew'].includes(item.item_state) ? `${item.item_state}-test` : item.item_state;
        const target = { to, parms: item.item_parms };
        if (event.ctrlKey) this.navigator?.newTab(target); else this.navigator?.go(target);
    }
}
